import React from "react";
import { View, StyleSheet } from "react-native";
import { MotiView, AnimatePresence } from "moti";
import ChatLoader from "../../common/status/ChatLoader/ChatLoader";

const ProcessingMessageBox = () => {
  return (
    <View style={styles.container}>
      <AnimatePresence>
        <MotiView
          key="loader"
          style={styles.loader}
          from={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ type: "timing", duration: 500 }}>
          <ChatLoader />
        </MotiView>
      </AnimatePresence>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    marginTop: 20,
    marginBottom: 10,
    minHeight: 140,
  },
  loader: {
    position: "absolute",
    top: 0,
    alignSelf: "center",
  },
});

export default ProcessingMessageBox;
